<flame-empty-state icon="mobile-payment">
  <flame-empty-state-content>
    <h2>¡No te quedes sin saldo!</h2>
    <div class="fl-empty-text">
    Si desactivas la recarga automática, tendrás que hacer tus recargas de forma manual.
    </div>
    <button flameButton color="primary" (click)="onClick()">Continuar</button>
  </flame-empty-state-content>
</flame-empty-state>
